<div class="full-modal-config__form-control-row health-monitor-port-ip-group">
    <div class="full-modal-config__form-control">
        <avi-input-container noMarginTop>
            <label
                aviLabelWithTooltip
                objectType="{{ objectTypes.HealthMonitor }}"
                fieldName="monitor_ip"
                for="monitor-ip"
            >
                {{ globalL10nKeys.healthMonitorIpAddressLabel | vtranslate }}
            </label>
            <input
                clrInput
                id="monitor-ip"
                name="monitor-ip"
                [(ngModel)]="editable.config.monitor_ip.address"
                objectType="{{ objectTypes.HealthMonitor }}"
                fieldName="monitor_ip"
                placeholder="{{ globalL10nKeys.ipAddressPlaceholder | vtranslate }}"
                [disabled]="!!editable.id"
                regexPattern="ip"
            />
        </avi-input-container>
    </div>
    <div 
        class="full-modal-config__form-control"
        *ngIf="!hidePortInput"
    >
        <avi-input-container noMarginTop>
            <label
                aviLabelWithTooltip
                objectType="{{ objectTypes.HealthMonitor }}"
                fieldName="monitor_port"
                for="monitor-port"
                [required]="editable.config.is_federated"
            >
                {{ globalL10nKeys.healthMonitorPortInputLabel | vtranslate }}
            </label>
            <input
                clrInput
                type="number"
                id="monitor-port"
                name="monitor-port"
                class="sel-failed-checks"
                [(ngModel)]="editable.config.monitor_port"
                configFieldInputValidation
                objectType="{{ objectTypes.HealthMonitor }}"
                fieldName="monitor_port"
                placeholder="{{ globalL10nKeys.healthMonitorPortInputPlaceholder | vtranslate }}"
                [disabled]="!!editable.id"
                [required]="editable.config.is_federated"
            />
        </avi-input-container>
    </div>
</div>
